import { EntityStatus, EntityType, MenuModel, StepCategory } from '@shared/models/menu.model';

export const getMockMenu = (): MenuModel => {
  return {
    total: 1,
    per_page: 50,
    current_page: 1,
    last_page: 1,
    next_page_url: null,
    prev_page_url: null,
    from: 1,
    to: 1,
    current_progression: {
      current_step: {
        id: 626,
        title: 'Step 4',
        name: 'Wrap-up',
        description: '1 minute',
        status: EntityStatus.current,
        fullUrl: '/potentialife-course/cycle-3/lifemap-3/step-5',
      },
      current_module: {
        id: 101,
        title: 'LifeMap 3',
        name: 'LifeMap',
        description: '4 Steps',
        fullUrl: '/potentialife-course/cycle-3/lifemap-3',
      },
      current_cycle: {
        id: 3,
        title: 'Level 3',
        name: 'Grow',
        description: '12 Modules',
        fullUrl: '/potentialife-course/cycle-3',
      },
      last_step: {
        id: 625,
        stepable_id: 101,
        stepable_type: 'App\\Models\\Module',
        title: 'Step 4',
        name: 'LifeMap',
        description: '1 minute',
        slug: 'step-4',
        category: null,
        type: 'LifeMap',
        hideStepInMenu: 0,
        congrats: '<p>Well done, your progress has been saved. Continue to your next step below.</p>',
        lft: 6,
        rgt: 7,
        depth: 1,
        created_at: '2019-06-26 11:16:22',
        updated_at: '2019-06-26 11:16:22',
        deleted_at: null,
        order: 0,
        parent_id: null,
        status: EntityStatus.completed,
        fullUrl: '/potentialife-course/cycle-3/lifemap-3/step-4',
        pivot: {
          participant_id: 2103,
          step_id: 625,
          step_order: 1003001003,
          created_at: '2024-03-21 13:54:45',
          updated_at: '2024-03-21 13:54:45',
        },
        module: {
          id: 101,
          cycle_id: 3,
          title: 'LifeMap 3',
          name: 'LifeMap',
          description: '4 Steps',
          content: null,
          slug: 'lifemap-3',
          lft: 2,
          rgt: 3,
          depth: 1,
          parent_id: null,
          created_at: '2019-06-26 11:16:22',
          updated_at: '2019-06-26 12:27:13',
          deleted_at: null,
          description_overridden: 0,
          custom_description: null,
          fullUrl: '/potentialife-course/cycle-3/lifemap-3',
          cycle: {
            id: 3,
            course_id: 1,
            title: 'Level 3',
            name: 'Grow',
            description: '12 Modules',
            slug: 'cycle-3',
            content: null,
            lft: 6,
            rgt: 7,
            depth: 1,
            parent_id: null,
            created_at: null,
            updated_at: '2020-10-23 11:17:18',
            deleted_at: null,
            description_overridden: 0,
            custom_description: null,
            fullUrl: '/potentialife-course/cycle-3',
            progress: {
              completed: 3,
              remaining: 116,
              total: 119,
              percent: '3',
            },
            course: {
              id: 1,
              name: 'Potentialife Course',
              slug: 'potentialife-course',
              description: 'This is the course content that users experience',
              content: null,
              lft: 2,
              rgt: 3,
              depth: 1,
              parent_id: null,
              created_at: '2017-02-13 11:07:23',
              updated_at: '2019-06-26 11:15:54',
              deleted_at: null,
              fullUrl: '/potentialife-course',
            },
          },
        },
      },
      current_lifeact_step: {
        id: 360,
        title: 'Step 10',
        name: 'LifeAct',
        description: '2 minute',
        fullUrl: '/potentialife-course/cycle-2/module-20/step-10',
      },
    },
    menudata: [
      {
        id: 1,
        name: 'Potentialife Course',
        fullUrl: '/potentialife-course',
        status: EntityStatus.current,
        children: [
          {
            id: 1,
            lft: 2,
            type: EntityType.level,
            title: 'Level 1',
            name: 'Ignite',
            description: '13 Modules',
            fullUrl: '/potentialife-course/cycle-1',
            progress: {
              completed: 131,
              remaining: 2,
              total: 133,
              percent: '98',
            },
            status: EntityStatus.completed,
            children: [
              {
                id: 99,
                lft: 4,
                type: EntityType.module,
                title: 'Welcome to Potentialife',
                name: 'Getting started',
                description: '5 Steps',
                fullUrl: '/potentialife-course/cycle-1/lifemap-1',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 612,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'A word from Angus',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/lifemap-1/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 613,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'Key program components',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/lifemap-1/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 616,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Introducing LifeMap',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/lifemap-1/step-3-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 614,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'LifeMapping',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/lifemap-1/step-3',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 615,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Introducing LifeChanges',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/lifemap-1/step-4',
                    status: EntityStatus.completed,
                  },
                ],
              },
              {
                id: 1,
                lft: 6,
                type: EntityType.module,
                title: 'Module 1',
                name: 'Encounter Strengths',
                description: '12 Steps',
                fullUrl: '/potentialife-course/cycle-1/module-1',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 4,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-1/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 5,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'It\u2019s the abilities not the disabilities that count',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-1/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 6,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Your starting point',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-1/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 7,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Your influences',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-1/step-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 8,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Weakness-fixing as damage limitation',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-1/step-6',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 11,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'How often are you using your strengths?',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-1/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 13,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Identifying your strengths',
                    description: '15 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-1/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 15,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Revealing your hidden strengths',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-1/step-9',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 16,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-1/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 17,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-1/step-11',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 2,
                lft: 14,
                type: EntityType.module,
                title: 'Module 2',
                name: 'Experiment Strengths',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-1/module-2',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 18,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-2/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 19,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-2/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 20,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Passion and performance strengths',
                    description: '6 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-2/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 28,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Your passion strengths',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-2/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 29,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Your peak potential zone',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-2/step-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 30,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Small changes make a big difference',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-2/step-6',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 31,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Increasing your time in your peak potential zone',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-2/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 32,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Send out strengths requests',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-2/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 33,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-2/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 27,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-2/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 5,
                lft: 20,
                type: EntityType.module,
                title: 'Module 3',
                name: 'Encounter Health',
                description: '11 steps',
                fullUrl: '/potentialife-course/cycle-1/module-3',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 35,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 36,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 38,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: "From 'coping with stress' to 'energy management'",
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 37,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'What is your energy baseline?',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 39,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Energy management diagnostic',
                    description: '6 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 122,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Energy management diagnostic',
                    description: '6 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-5-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 123,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Energy management diagnostic',
                    description: '6 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-5-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 124,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Energy management diagnostic',
                    description: '6 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-5-3',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 40,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'The 3 levels of recovery',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-6',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 41,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Your energy diagnostic results',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 42,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Your recovery baseline',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 43,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'What will you change this week?',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-9',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 44,
                    lft: 26,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 45,
                    lft: 28,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-3/step-11',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 6,
                lft: 24,
                type: EntityType.module,
                title: 'Module 4',
                name: 'Experiment Health',
                description: '11 steps',
                fullUrl: '/potentialife-course/cycle-1/module-4',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 46,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 47,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2  minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 48,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'The Blue Zones and the importance of nutrition',
                    description: '6 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 49,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Analyzing your diet',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 50,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'The importance of physical activity',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 51,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Reflect on your levels of physical activity',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 52,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'The importance of sleep',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-7',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 53,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Reflect on your sleep',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 54,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Small changes',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 55,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Summary',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 56,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-4/step-11',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 7,
                lft: 28,
                type: EntityType.module,
                title: 'Module 5',
                name: 'Encounter Absorption',
                description: '12 steps',
                fullUrl: '/potentialife-course/cycle-1/module-5',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 57,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 58,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 59,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Modern mindlessness',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 60,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'How engaged are you?',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 61,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Mindfulness training',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 62,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Diagnosing your level of mindfulness',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 125,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Diagnosing your level of mindfulness',
                    description: '4 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-6-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 63,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Questionnaire results and actions',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 64,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Everyday mindfulness',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-8',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 65,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Your first mindfulness exercise',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-9',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 66,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Preparing your mindfulness LifeActs',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-10',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 67,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-11',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 68,
                    lft: 26,
                    type: EntityType.step,
                    title: 'Step 12',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-5/step-12',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 8,
                lft: 40,
                type: EntityType.module,
                title: 'Module 6',
                name: 'Experiment Absorption',
                description: '13 steps',
                fullUrl: '/potentialife-course/cycle-1/module-6',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 69,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 70,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 71,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'What is flow?',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 72,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'How much flow do you experience?',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 73,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Boredom, anxiety and flow.',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 74,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'How bored are you?',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 75,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'How anxious are you?',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 76,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Environments that are conducive to flow',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-8',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 77,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Improving your flow environment',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-9',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 78,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Defining flow goals',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 79,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'Your flow goals',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-11',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 80,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 12',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-12',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 238,
                    lft: 26,
                    type: EntityType.step,
                    title: 'Step 13',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-6/step-13',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 9,
                lft: 44,
                type: EntityType.module,
                title: 'Module 7',
                name: 'Encounter Relationships',
                description: '9 steps',
                fullUrl: '/potentialife-course/cycle-1/module-7',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 81,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 82,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 83,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Positive relationships drive workplace performance',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 84,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Your best friend at work',
                    description: '6 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 240,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Your best friend at work',
                    description: '6 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-4-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 85,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Making real relationships a priority',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 86,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Relationships assessment',
                    description: '7 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 241,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Relationships assessment',
                    description: '7 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-6-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 242,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Relationships assessment',
                    description: '7 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-6-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 243,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Relationships assessment',
                    description: '7 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-6-3',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 244,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Relationships assessment',
                    description: '7 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-6-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 245,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Relationships assessment',
                    description: '7 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-6-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 87,
                    lft: 26,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Relationships assessment results',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 88,
                    lft: 28,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-8',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 89,
                    lft: 30,
                    type: EntityType.step,
                    title: 'Step  9',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-7/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 10,
                lft: 52,
                type: EntityType.module,
                title: 'Module 8',
                name: 'Experiment Relationships',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-1/module-8',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 90,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 91,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 92,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Authenticity',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 93,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Reflect on your levels of authenticity',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 94,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Positivity',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 95,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Reflect on your levels of positivity',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 96,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'The benefactor zone',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-7',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 97,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Discover your benefactor zone',
                    description: '6 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 246,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Discover your benefactor zone',
                    description: '6 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-8-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 98,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 99,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-8/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 11,
                lft: 60,
                type: EntityType.module,
                title: 'Module 9',
                name: 'Encounter Purpose',
                description: '11 steps',
                fullUrl: '/potentialife-course/cycle-1/module-9',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 100,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 101,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 102,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'The importance of purpose',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 103,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'How do you feel about this?',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 104,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Meaning and commitment',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 105,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Your purposeful living zone',
                    description: '6 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 247,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Your purposeful living zone',
                    description: '6 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-6-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 106,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'The benefits of purposeful living',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-7',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 107,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Your purpose statement',
                    description: '7 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 108,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Your purpose wordcloud',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-9',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 109,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 110,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-9/step-11',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 12,
                lft: 66,
                type: EntityType.module,
                title: 'Module 10',
                name: 'Experiment Purpose',
                description: '8 steps',
                fullUrl: '/potentialife-course/cycle-1/module-10',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 111,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 112,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 113,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'The goal of goals',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 114,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Making day to day life more purposeful',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 115,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Meaning in your work',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 116,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Reframing work to make it more meaningful',
                    description: '6 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 117,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10/step-7',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 118,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10/step-8',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 102,
                lft: 70,
                type: EntityType.module,
                title: 'LifeMap 2',
                name: 'LifeMap',
                description: '6 Steps',
                fullUrl: '/potentialife-course/cycle-1/lifemap-2',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 628,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/lifemap-2/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 627,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/lifemap-2/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 629,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'How to LifeMap',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/lifemap-2/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 631,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'LifeMap',
                    description: '60 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/lifemap-2/step-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 632,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Wrap-up',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/lifemap-2/step-6',
                    status: EntityStatus.completed,
                  },
                ],
              },
              {
                id: 65,
                lft: 72,
                type: EntityType.module,
                title: 'Your progress',
                name: 'Your progress',
                description: '6 Steps',
                fullUrl: '/potentialife-course/cycle-1/module-10-1',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 248,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Your Strengths progress',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10-1/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 251,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'Your Health progress',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10-1/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 252,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Your Absorption progress',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10-1/step-3',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 633,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Your Relationships progress',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10-1/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 634,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Your Purpose progress',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10-1/step-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 635,
                    category: StepCategory.certificate,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Wrap-up documents',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-1/module-10-1/step-6',
                    status: EntityStatus.completed,
                  },
                ],
              },
            ],
          },
          {
            id: 2,
            lft: 4,
            type: EntityType.level,
            title: 'Level 2',
            name: 'Lead',
            description: '11 Modules',
            fullUrl: '/potentialife-course/cycle-2',
            progress: {
              completed: 106,
              remaining: 0,
              total: 106,
              percent: '100',
            },
            status: EntityStatus.completed,
            children: [
              {
                id: 13,
                lft: 4,
                type: EntityType.module,
                title: 'Module 1',
                name: 'Pick Strengths',
                description: '11 Steps',
                fullUrl: '/potentialife-course/cycle-2/module-11',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 253,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 254,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'Reflect on strengths journey so far',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-3',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 255,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Strengths and self-confidence',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-4',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 256,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Refine your understanding of your PPZ',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 257,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Explore your 360 strengths stories',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 258,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Signature strengths',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-7',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 259,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Picking your signature strength',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 260,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Entering your own virtuous circle',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-9',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 261,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 262,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-11',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                  {
                    id: 642,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step To delete',
                    name: 'This step in NOT on PROD, ignore this if you see it, it means we did not have time to remove it yet',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-11/step-1',
                    status: EntityStatus.completed,
                  },
                ],
              },
              {
                id: 14,
                lft: 10,
                type: EntityType.module,
                title: 'Module 2',
                name: 'Lead Strengths',
                description: '9 steps',
                fullUrl: '/potentialife-course/cycle-2/module-12',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 263,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-12/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 264,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-12/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 265,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Instilling belief in others',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-12/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 268,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Reflect on someone who saw your strengths',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-12/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 269,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Complementary strengths',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-12/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 270,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Managing a weakness with complementary strengths',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-12/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 271,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Leading with complementary strengths',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-12/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 272,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-12/step-8',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 273,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-12/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 15,
                lft: 16,
                type: EntityType.module,
                title: 'Module 3',
                name: 'Pick Health',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-2/module-13',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 266,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-13/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 267,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-13/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 274,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Reflect on your health journey so far',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-13/step-3',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 278,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Emotional restorers and depletors',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-13/step-4',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 276,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Understanding what energizes you!',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-13/step-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 277,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Common restorers and depletors',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-13/step-6',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 279,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Identifying your depletors and restorers',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-13/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 280,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Managing your energy with depletors and restorers',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-13/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 281,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Summary',
                    description: '1 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-13/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 282,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'LifeAct',
                    description: '2 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-13/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 16,
                lft: 26,
                type: EntityType.module,
                title: 'Module 4',
                name: 'Lead Health',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-2/module-14',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 283,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-14/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 284,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-14/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 285,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Energy and positivity in teams',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-14/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 286,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Your experiences of emotional contagion',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-14/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 361,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 4-1',
                    name: 'Your experiences of emotional contagion',
                    description: '4 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-2/module-14/step-4-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 287,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Opportunities to lead with positivity',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-14/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 289,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Practical ideas for leading with more  positivity',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-14/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 290,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Leading positive, healthy teams',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-14/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 291,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-14/step-8',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 292,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-14/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 17,
                lft: 34,
                type: EntityType.module,
                title: 'Module 5',
                name: 'Pick Absorption',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-2/module-15',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 294,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-15/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 295,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-15/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 297,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Reflect on your absorption journey so far',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-15/step-3',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 296,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'The Power of Meditation',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-15/step-4',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 300,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Practicing Meditation',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-15/step-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 298,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Meditation Techniques',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-15/step-6',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 448,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Bringing Meditation to your Life',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-15/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 303,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Summary',
                    description: '1 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-15/step-8',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 304,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-15/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 18,
                lft: 38,
                type: EntityType.module,
                title: 'Module 6',
                name: 'Lead Absorption',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-2/module-16',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 305,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 306,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 307,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'The Power of Listening',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 309,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Reflect On Your Listening Style',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 449,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 4-1',
                    name: 'Reflect on your Listening Style',
                    description: '2 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-4-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 450,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 4-2',
                    name: 'Reflect on your Listening Style',
                    description: '2 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-4-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 311,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Listening as a Leader',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 312,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Your Results from Listening Questionnaire',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 314,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Planning to Practice Better Listening',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 451,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Lead with Listening',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 316,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Summary',
                    description: '1 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 317,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-16/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 19,
                lft: 42,
                type: EntityType.module,
                title: 'Module 7',
                name: 'Pick Relationships',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-2/module-17',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 318,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 319,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 321,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Reflect on your relationships journey so far',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-3',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 320,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'The Right Type of Recognition',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-4',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 322,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Reflect on Your 360 Feedback',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 452,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Reflect on Your 360 Feedback',
                    description: '4 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-5-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 339,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'The Power of Gratitude',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-6',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 340,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Write a Gratitude Letter',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 453,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Write a Gratitude Letter',
                    description: '3 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-7-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 324,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Summary',
                    description: '1 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-8',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 325,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'LifeAct',
                    description: '2 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-17/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 20,
                lft: 48,
                type: EntityType.module,
                title: 'Module 8',
                name: 'Lead Relationships',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-2/module-18',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 326,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-18/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 327,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-18/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 328,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'The Power of Active Constructive Responding (ACR)',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-18/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 331,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Use Active Constructive Responding to Lead with Positivity',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-18/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 454,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Use Active Constructive Responding to Lead with Positivity',
                    description: '3 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-2/module-18/step-4-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 333,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'The Power of Psychological Safety',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-18/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 335,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'How to Create Psychological Safety as a Leader',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-18/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 336,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Lead with Psychological Safety',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-18/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 337,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-18/step-8',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 338,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'LifeAct',
                    description: '2 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-18/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 21,
                lft: 58,
                type: EntityType.module,
                title: 'Module 9',
                name: 'Pick Purpose',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-2/module-19',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 341,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 342,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 344,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Reflect on your purposeful story so far',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-3',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 343,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'The Power of Stories',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-4',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 345,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Reflect on your Potentialife story',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-5',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 346,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Practical Tips for Constructing a Life Story',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-6',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 347,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Write Your Purposeful Story',
                    description: '6 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 348,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Write Your Purposeful Story',
                    description: '6 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-7-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 455,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Reflect on your story',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 349,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Summary',
                    description: '1 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 350,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'LifeAct',
                    description: '2 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-19/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 22,
                lft: 64,
                type: EntityType.module,
                title: 'Module 10',
                name: 'Lead Purpose',
                description: '10 Steps',
                fullUrl: '/potentialife-course/cycle-2/module-20',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 351,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 352,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 353,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'The Power of Leading with Purpose',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-3',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 354,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Reflect on your team\u2019s purpose',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 355,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Reflect on your team\u2019s purpose',
                    description: '4 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-4-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 356,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'The Principles of Leading with Purpose',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-5',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 357,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: "Defining your team's purposeful goal",
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-6',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 358,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Walk the talk - leading with purpose',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-7',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 456,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Leading with Purpose',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-8',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 359,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Summary',
                    description: '1 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-9',
                    status: EntityStatus.completed,
                    category: StepCategory.video,
                  },
                  {
                    id: 360,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'LifeAct',
                    description: '2 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20/step-10',
                    status: EntityStatus.completed,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 66,
                lft: 70,
                type: EntityType.module,
                title: 'Wrap-up',
                name: 'Wrap-up',
                description: '2 Steps',
                fullUrl: '/potentialife-course/cycle-2/module-20-1',
                status: EntityStatus.completed,
                children: [
                  {
                    id: 457,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20-1/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 459,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'Wrap-up',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-2/module-20-1/step-3',
                    status: EntityStatus.completed,
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            lft: 6,
            type: EntityType.level,
            title: 'Level 3',
            name: 'Grow',
            description: '12 Modules',
            fullUrl: '/potentialife-course/cycle-3',
            progress: {
              completed: 3,
              remaining: 116,
              total: 119,
              percent: '3',
            },
            status: EntityStatus.current,
            children: [
              {
                id: 101,
                lft: 2,
                type: EntityType.module,
                title: 'LifeMap 3',
                name: 'LifeMap',
                description: '4 Steps',
                fullUrl: '/potentialife-course/cycle-3/lifemap-3',
                status: EntityStatus.current,
                children: [
                  {
                    id: 622,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Welcome to Level 3',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/lifemap-3/step-1',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 623,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'How to LifeMap',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/lifemap-3/step-2',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 625,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'LifeMap',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/lifemap-3/step-4',
                    status: EntityStatus.completed,
                  },
                  {
                    id: 626,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Wrap-up',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/lifemap-3/step-5',
                    status: EntityStatus.current,
                  },
                ],
              },
              {
                id: 23,
                lft: 4,
                type: EntityType.module,
                title: 'Module 1',
                name: 'Change is Possible',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-3/module-21',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 239,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-21/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 362,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'Changing Neural Pathways',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-21/step-3',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 363,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Change in Action',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-21/step-4',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 462,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Change in Action',
                    description: '3 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-3/module-21/step-4-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 364,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'The Power of \u2018Just Do It\u2019',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-21/step-5',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 365,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Just Do It Today!',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-21/step-6',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 366,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-21/step-7',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 367,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'LifeAct',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-21/step-8',
                    status: EntityStatus.locked,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 24,
                lft: 12,
                type: EntityType.module,
                title: 'Module 2',
                name: 'Overcome for Strengths',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-3/module-22',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 368,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 369,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 370,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Reflect on Your Strengths Journey',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-3',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 371,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Taking Responsibility For Your Own Change',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-4',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 372,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Taking Responsibility',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-5',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 463,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Taking Responsibility',
                    description: '2 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-5-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 464,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Taking Responsibility',
                    description: '3 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-5-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 373,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'The Growth Mindset',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-6',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 374,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: ' Your Mindset',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-7',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 468,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Developing the growth mindset in others',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-8',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 375,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: "Don't Take Strengths Too Far",
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-9',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 376,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Humility and Feedback',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-10',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 465,
                    lft: 26,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-11',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 466,
                    lft: 28,
                    type: EntityType.step,
                    title: 'Step 12',
                    name: 'LifeActs',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-22/step-12',
                    status: EntityStatus.locked,
                  },
                ],
              },
              {
                id: 25,
                lft: 18,
                type: EntityType.module,
                title: 'Module 3',
                name: 'Overcome for Health',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-3/module-23',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 377,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 378,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 379,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Reflect on Your Health Journey',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-3',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 380,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'The Barrier of Perceived Time Pressure',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-4',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 381,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Prioritizing Your Health',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-5',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 382,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: "The Barrier of the 'All or Nothing' Approach",
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-6',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 383,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Inconveniencing Ourselves!',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-7',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 384,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'The Barrier of Procrastination',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-8',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 385,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Overcoming Procrastination',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-9',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 469,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'The Barrier of Temptation',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-10',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 470,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'Improving Our Environments',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-11',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 471,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 12',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-12',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 472,
                    lft: 26,
                    type: EntityType.step,
                    title: 'Step 13',
                    name: 'LifeActs',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-23/step-13',
                    status: EntityStatus.locked,
                  },
                ],
              },
              {
                id: 26,
                lft: 22,
                type: EntityType.module,
                title: 'Module 4',
                name: 'Overcome for Absorption',
                description: '10 steps',
                fullUrl: '/potentialife-course/cycle-3/module-24',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 386,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 387,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 388,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Reflect on Your Absorption Journey',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-3',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 389,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Being Too Busy',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-4',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 473,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Time Affluence',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-5',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 390,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Time Affluence',
                    description: '4 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-5-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 391,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Reduce Multitasking',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-6',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 392,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Overcome for Multitasking',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-7',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 393,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'The Right Kind of Stress',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-8',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 475,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Optimize Your Stress Levels',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-9',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 476,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-10',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 394,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-24/step-11',
                    status: EntityStatus.locked,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 27,
                lft: 32,
                type: EntityType.module,
                title: 'Module 5',
                name: 'Overcome for Relationships',
                description: '12 Steps',
                fullUrl: '/potentialife-course/cycle-3/module-25',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 395,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 396,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 397,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Reflect on Your Relationships Journey',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-3',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 398,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: "Don't Blame The Other Person",
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-4',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 400,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Take Responsibility',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-5',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 401,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Successful Givers',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-6',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 402,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Be a Giver',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-7',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 479,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: "Don't be taken advantage of",
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-8',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 477,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: "Learn to Say 'No'",
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-9',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 403,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-10',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 404,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'LifeAct',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-25/step-11',
                    status: EntityStatus.locked,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 28,
                lft: 36,
                type: EntityType.module,
                title: 'Module 6',
                name: 'Overcome for Purpose',
                description: '11 Steps',
                fullUrl: '/potentialife-course/cycle-3/module-26',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 405,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 406,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 407,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Reflect on Your Purpose Journey',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-3',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 408,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'The Fear of Failure',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-4',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 409,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Learning to Fail',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-5',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 410,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'The Inclination to Conform',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-6',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 411,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Going Against the Grain',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-7',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 483,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: "From 'Perfect'  to 'Good Enough'",
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-8',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 484,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: "Your 'Good Enough' Life",
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-9',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 490,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: "Your 'Good Enough' Life",
                    description: '4 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-9-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 491,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: "Your 'Good Enough' Life",
                    description: '4 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-9-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 412,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Summary',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-10',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 413,
                    lft: 26,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-26/step-11',
                    status: EntityStatus.locked,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 29,
                lft: 46,
                type: EntityType.module,
                title: 'Module 7',
                name: 'Appreciative Inquiry',
                description: '12 Steps',
                fullUrl: '/potentialife-course/cycle-3/module-27',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 414,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 415,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 416,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'What is Appreciative Inquiry?',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-3',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 417,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Your Own Positive Past (step 1)',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-4',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 418,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'Fantastic Future',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-5',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 419,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Your Own Fantastic Future (step 2)',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-6',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 485,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Concrete Commitments',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-7',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 486,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Your Own Concrete Commitments (step 3)',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-8',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 487,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'Authentic Action',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-9',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 488,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Your Own Authentic Action (step 4)',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-10',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 492,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 10',
                    name: 'Your Own Authentic Action (step 4)',
                    description: '3 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-10-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 420,
                    lft: 24,
                    type: EntityType.step,
                    title: 'Step 11',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-11',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 421,
                    lft: 26,
                    type: EntityType.step,
                    title: 'Step 12',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-27/step-12',
                    status: EntityStatus.locked,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 30,
                lft: 50,
                type: EntityType.module,
                title: 'Module 8',
                name: 'The Leader as Teacher',
                description: '10 Steps',
                fullUrl: '/potentialife-course/cycle-3/module-28',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 422,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 423,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 424,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Why Do We Teach?',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-3',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 425,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Practice Teaching',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-4',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 427,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Practice Teaching',
                    description: '5 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-4-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 500,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Practice Teaching',
                    description: '3 minutes',
                    hideStepInMenu: true,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-4-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 426,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'The Most Successful Leaders',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-5',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 497,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Teach a SHARP Area',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-6',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 498,
                    lft: 18,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'The big idea',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-7',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 428,
                    lft: 20,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-8',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 429,
                    lft: 22,
                    type: EntityType.step,
                    title: 'Step 9',
                    name: 'LifeActs',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-28/step-9',
                    status: EntityStatus.locked,
                  },
                ],
              },
              {
                id: 31,
                lft: 56,
                type: EntityType.module,
                title: 'Module 9',
                name: 'Reminders',
                description: '9 Steps',
                fullUrl: '/potentialife-course/cycle-3/module-29',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 431,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-29/step-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 432,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-29/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 433,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'The Power of Reminders',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-29/step-3',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 499,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Reminders from Religion',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-29/step-4',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 435,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'How to Make a Habit Stick',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-29/step-5',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 436,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'Practical Reminders',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-29/step-6',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 437,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-29/step-7',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 438,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-29/step-8',
                    status: EntityStatus.locked,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 32,
                lft: 62,
                type: EntityType.module,
                title: 'Module 10',
                name: 'Ritualizing Behaviors',
                description: '10 Steps',
                fullUrl: '/potentialife-course/cycle-3/module-30',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 439,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'Introduction',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30/step-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 440,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My LifeChanges',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 442,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Friday Change vs Monday Change',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30/step-3',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 443,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: 'Creating Monday Change',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30/step-4',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 444,
                    lft: 10,
                    type: EntityType.step,
                    title: 'Step 5',
                    name: 'What You Really Really Want',
                    description: '4 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30/step-5',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 445,
                    lft: 12,
                    type: EntityType.step,
                    title: 'Step 6',
                    name: 'What Do I Really Really Want To Do?',
                    description: '5 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30/step-6',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 446,
                    lft: 14,
                    type: EntityType.step,
                    title: 'Step 7',
                    name: 'Summary',
                    description: '1 minute',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30/step-7',
                    status: EntityStatus.locked,
                    category: StepCategory.video,
                  },
                  {
                    id: 447,
                    lft: 16,
                    type: EntityType.step,
                    title: 'Step 8',
                    name: 'LifeAct',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30/step-8',
                    status: EntityStatus.locked,
                    category: StepCategory.lifeact,
                  },
                ],
              },
              {
                id: 67,
                lft: 72,
                type: EntityType.module,
                title: 'Wrap-up',
                name: 'Wrap-up',
                description: '4 Steps',
                fullUrl: '/potentialife-course/cycle-3/module-30-1',
                status: EntityStatus.locked,
                children: [
                  {
                    id: 494,
                    lft: 2,
                    type: EntityType.step,
                    title: 'Step 2',
                    name: 'My Level 3 Summary',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30-1/step-2',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 493,
                    lft: 4,
                    type: EntityType.step,
                    title: 'Step 1',
                    name: 'My LifeChanges',
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30-1/step-1',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 495,
                    category: StepCategory.certificate,
                    lft: 6,
                    type: EntityType.step,
                    title: 'Step 3',
                    name: 'Thank you',
                    description: '3 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30-1/step-3',
                    status: EntityStatus.locked,
                  },
                  {
                    id: 502,
                    lft: 8,
                    type: EntityType.step,
                    title: 'Step 4',
                    name: "What's next?",
                    description: '2 minutes',
                    hideStepInMenu: false,
                    fullUrl: '/potentialife-course/cycle-3/module-30-1/step-4',
                    status: EntityStatus.locked,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
};
